export enum AutoCompleteKey {
  ProductOwner = 'PRODUCT_OWNER',
}
